import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell, ProtectedRoute } from "./components/AppShell";
import { ToastStack } from "./components/ToastStack";
import { AuthCallbackPage } from "./pages/AuthCallbackPage";
import { FacultyAnalyticsPage } from "./pages/faculty/FacultyAnalyticsPage";
import { FacultyCohortsPage } from "./pages/faculty/FacultyCohortsPage";
import { FacultyCurriculumPage } from "./pages/faculty/FacultyCurriculumPage";
import { FacultyHomePage } from "./pages/faculty/FacultyHomePage";
import { LandingPage } from "./pages/LandingPage";
import { DashboardPage } from "./pages/student/DashboardPage";
import { ProfilePage } from "./pages/student/ProfilePage";
import { QuestPage } from "./pages/student/QuestPage";
import { WorldMapPage } from "./pages/student/WorldMapPage";

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route
          path="/app"
          element={
            <ProtectedRoute roles={["student", "instructor", "admin"]}>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/app/map" replace />} />
          <Route path="map" element={<WorldMapPage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="quest/:questId" element={<QuestPage />} />
        </Route>
        <Route
          path="/faculty"
          element={
            <ProtectedRoute roles={["instructor", "admin"]}>
              <AppShell faculty />
            </ProtectedRoute>
          }
        >
          <Route index element={<FacultyHomePage />} />
          <Route path="curriculum" element={<FacultyCurriculumPage />} />
          <Route path="cohorts" element={<FacultyCohortsPage />} />
          <Route path="analytics" element={<FacultyAnalyticsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ToastStack />
    </>
  );
}
